import { render, staticRenderFns } from "./MainMessage.vue?vue&type=template&id=12e319b3&"
import script from "./MainMessage.vue?vue&type=script&lang=js&"
export * from "./MainMessage.vue?vue&type=script&lang=js&"
import style0 from "./MainMessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports